module.exports = __webpack_public_path__ + "static/img/apply_bg.16010f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apply_bg.png
// module id = nxbv
// module chunks = 54